module.exports = __webpack_public_path__ + "static/img/f1.1160a94.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/center/dam/f1.png
// module id = 4e0s
// module chunks = 0